import React from "react";
import { TiArrowSortedUp } from "react-icons/ti";
import { TiArrowSortedDown } from "react-icons/ti";
import { Schedule } from "../../../../models/Schedule.tsx";


type ITableComponents = {
    game: Schedule;
    onToggleColumns: { (column: React.MouseEvent<HTMLDivElement>): void };
    formattedDate: any
}

export function TableComponentsLive(props: ITableComponents) {
    const { game, onToggleColumns, formattedDate } = props;
    const fullMarketTitle = game.odds?.[0]?.market || "";
    const marketTitle = fullMarketTitle.split(" ").slice(0, 2).join(" ").toLowerCase();
    const shouldShowMarketTitle = marketTitle.includes("half") || marketTitle.includes("quarter") || marketTitle.includes("period");


    return (
        <>
            <div className="schedule-table">
                <div className='container-table '>
                    <div className='d-flex justify-content-between align-items-center'>
                        {/* <img src={game.leagueLogo} className="league-logo" alt="" /> */}
                        <span className='market-title teko'>{game.league?.name} Live </span>
                        {shouldShowMarketTitle && (
                            <div className="market-title teko">
                                {marketTitle}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="schedule-sticky-columns schedule-sticky-columns--live">
                <div className="d-flex align-items-center color-title-live">
               
                    <div className="container-date team-name-container">
                        <span className="group ps-1">{formattedDate}</span>
                    </div>

                    <div className="spread-container" data-toggle=".market-0" data-pair=".market-1" onClick={onToggleColumns}>
                        <span className="title-with-arrows">
                            <span className="title-table-game d-none d-lg-block">SPREAD</span>
                            <span className="title-table-game d-lg-none">SPREAD / ML</span>
                            <span className="arrow-icons">
                                <TiArrowSortedUp className="arrow-up" />
                                <TiArrowSortedDown className="arrow-down" />
                            </span>
                        </span>
                    </div>
                    <div className="moneyline-container d-none d-lg-block">
                        <span className="title-table-game d-none d-lg-block">MONEYLINE</span>
                    </div>
                    <div className="total-container" data-toggle=".market-3" data-default=".market-0, .market-2" data-is-full={true} onClick={onToggleColumns}>
                        <span className="title-with-arrows">
                            <span className="title-table-game d-none d-lg-block">TOTAL</span>
                            <span className="title-table-game d-lg-none">TOTAL/TT</span>
                            <span className="arrow-icons">
                                <TiArrowSortedUp className="arrow-up" />
                                <TiArrowSortedDown className="arrow-down" />
                            </span>
                        </span>
                    </div>
                    <div className="over-under-container d-none d-lg-block">
                        <span className="title-table-game">TEAM TOTAL</span>
                    </div>
                </div>
            </div>
        </>
    );

}
